import { render, staticRenderFns } from "./PublishWorkflowDialog.vue?vue&type=template&id=016333f2&scoped=true"
import script from "./PublishWorkflowDialog.vue?vue&type=script&lang=js"
export * from "./PublishWorkflowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016333f2",
  null
  
)

export default component.exports